{
  document.addEventListener("DOMContentLoaded", function () {
    const galleryTabs = document.querySelectorAll(".products__section");
    galleryTabs.forEach((gallery) => {
      const tabs = gallery.querySelectorAll(".tabs_list_item ul li");
      const images = gallery.querySelectorAll(
        ".tabs__products_List .Products__rows",
      );
      if (tabs.length > 0 && images.length > 0) {
        tabs[0].classList.add("active");
        images[0].classList.add("active");
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          tabs.forEach((t) => t.classList.remove("active"));
          images.forEach((img) => img.classList.remove("active"));
          tab.classList.add("active");
          if (images[index]) {
            images[index].classList.add("active");
          }
        });
      });
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const videoBoxes = document.querySelectorAll(".why-choose-video-box");
    let currentlyPlaying = null;
    videoBoxes.forEach((box) => {
      const video = box.querySelector("video");
      const playBtn = box.querySelector(".video-playBtn");
      playBtn.addEventListener("click", function () {
        if (currentlyPlaying === video) {
          video.pause();
          box.classList.remove("active");
          playBtn.classList.remove("active");
          currentlyPlaying = null;
          return;
        }
        if (currentlyPlaying) {
          currentlyPlaying.pause();
          currentlyPlaying
            .closest(".why-choose-video-box")
            .classList.remove("active");
          currentlyPlaying
            .closest(".why-choose-video-box")
            .querySelector(".video-playBtn")
            .classList.remove("active");
        }
        video.play();
        box.classList.add("active");
        playBtn.classList.add("active");
        currentlyPlaying = video;
      });
      video.addEventListener("pause", function () {
        if (currentlyPlaying === video) {
          box.classList.remove("active");
          playBtn.classList.remove("active");
          currentlyPlaying = null;
        }
      });
      video.addEventListener("ended", function () {
        box.classList.remove("active");
        playBtn.classList.remove("active");
        currentlyPlaying = null;
      });
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const allAccordions = document.querySelectorAll(".accordion_cus");
    allAccordions.forEach((accordion) => {
      const items = accordion.querySelectorAll(".acco_cus_item");
      if (items.length > 0) {
        items[0].classList.add("open");
      }
      items.forEach((item) => {
        const header = item.querySelector(".acc-header");
        header.addEventListener("click", () => {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains("open")) {
              otherItem.classList.remove("open");
            }
          });
          item.classList.toggle("open");
        });
      });
    });
  });
}

document.addEventListener("DOMContentLoaded",  () => {
    const containers = document.querySelectorAll(".LoopMarque");

    if (!containers.length) return;

    containers.forEach((container) => {
        const items = [...container.querySelectorAll(".slider__item")];

        if (!items.length) return;

        const images = [...container.querySelectorAll("img")];

        Promise.all(
            images.map((img) => {
                if (img.complete) {
                    return Promise.resolve();
                }

                return new Promise((resolve) => {
                    img.onload = img.onerror = resolve;
                });
            })
        ).then(() => {
            const containerWidth =
                (container.parentElement || container).offsetWidth ||
                window.innerWidth;

            const baseWidth = items.reduce(
                (total, item) => total + item.offsetWidth,
                0
            );

            if (!baseWidth) return;

            const repetitions = Math.max(
                1,
                Math.ceil(containerWidth / baseWidth) + 1
            );

            for (let i = 0; i < repetitions * 2 - 1; i++) {
                items.forEach((item) => {
                    container.appendChild(item.cloneNode(true));
                });
            }

            const distance = baseWidth * repetitions;

            const animation = gsap.to(container, {
                x: -distance,
                duration: distance / 40,
                ease: "linear",
                repeat: -1,
            });

            container.addEventListener("mouseenter", () => {
                animation.pause();
            });

            container.addEventListener("mouseleave", () => {
                animation.resume();
            });
        });
    });
});